import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getImageInfo = normalize.getImageInfo(function (args) {
  return ks.getImageInfo(args);
}, CONTAINER_NAME.KWAI);
export default getImageInfo;